var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { InfoToggle } from 'hx-ui';
export function InformationToggle(_a) {
    var title = _a.title, chevronColor = _a.chevronColor, children = _a.children, onClick = _a.onClick;
    return (_jsx(InfoToggle, __assign({ title: title, titleClass: "no-underline text-primary text-sm lg:text-xl", contentClass: "max-w-full text-sm lg:text-base px-5 py-1", variant: "inherit", chevronColor: chevronColor, onClick: onClick }, { children: children })));
}
